import { inject, Injectable, Injector, signal } from '@angular/core';
import { OfflineDownloadService } from '@shared/services/offline/offline-download.service';

@Injectable({ providedIn: 'root' })
export class NetworkStatusService {
  private readonly injector = inject(Injector);
  private readonly onlineSignal = signal(typeof navigator !== 'undefined' ? navigator.onLine : true);
  private offlineWarmTriggered = false;

  readonly isOnline = this.onlineSignal.asReadonly();

  constructor() {
    if (typeof window === 'undefined') {
      return;
    }

    const update = () => this.onlineSignal.set(navigator.onLine);
    window.addEventListener('online', () => {
      update();
      this.offlineWarmTriggered = false;
    });
    window.addEventListener('offline', () => {
      update();
      if (!this.offlineWarmTriggered) {
        this.offlineWarmTriggered = true;
        void this.injector.get(OfflineDownloadService).warmServiceRoutes();
      }
    });
  }
}
